import React from 'react';
import TeamPageLayout from '../components/TeamPageLayout';
import ConnectorTabContent from '../components/ConnectorTabContent';

/**
 * Connector tab only: layout (with shared tabs) + unified connector content.
 * ConnectorTabContent resolves the container from the registry and handles
 * loading / not found / not configured; the container loads its own report data.
 */
function TeamConnectorReportContainer({
  team = null,
  teamConnectorConfigurations = [],
  teamConnectorConfigurationsHasLoaded = false,
}) {
  return (
    <TeamPageLayout
      team={team}
      teamConnectorConfigurations={teamConnectorConfigurations}
      teamConnectorConfigurationsHasLoaded={
        teamConnectorConfigurationsHasLoaded
      }
    >
      <ConnectorTabContent
        team={team}
        teamConnectorConfigurations={teamConnectorConfigurations}
        teamConnectorConfigurationsHasLoaded={
          teamConnectorConfigurationsHasLoaded
        }
      />
    </TeamPageLayout>
  );
}

export default TeamConnectorReportContainer;
